export default function() {
    window.socket = {}
    if (!(window.io && window.io != "undefined")) {
        return
    }
    if (socket.connected && socket.connected != "undefined") {
        return
    }

    socket = io.connect(
        socketUrl + namespace,
        {
            forceNew: true,
            timeout: 2000,
            reconnectionAttempts: 3
        }
    )


    
    setTimeout(function() {
        console.log("[已接入websocket实时通知功能]", socket.connected)
    }, 2500)

    socket.on("server_connect", function(code, msg) {
        console.log("[正在链接服务器。。。。。。]", code, msg)
        socket.on("new_version", function(msg) {
            if (msg.data.type == "note" && localStorage.version) {
                $(".common_tip_bar.version").css("top", 0)
                localStorage.versionStatus = true
            }
            localStorage.version = msg.data.version_id
        })

        var userId = localStorage.user_id
        var teamId = localStorage.team_id
        var email = localStorage.email
        var teamsIds = []
        var teams = []

        if (localStorage.teams && localStorage.teams !== "undefined" && localStorage.teams !== undefined) {
            //本地有团队数据
            teams = JSON.parse(localStorage.teams)
            $.each(teams, function(i, ele) {
                teamsIds.push(ele.id)
            })

            //加入房间
            var rooms = teamsIds.join(",")

            if (userId && rooms) {
                try {
                    socket.emit(
                        "join_rooms",
                        {
                            rooms: userId + "," + email + "," + rooms
                        },
                        function(msg) {
                            console.log("加入房间", msg, userId)
                        }
                    )
                } catch (error) {
                    alert(error)
                }
            }
        }

        socket.on("server_team_message", function(msg) {
            if (msg.data.type == "authority") {
                var teamId = msg.data.team_id
                var teams = JSON.parse(localStorage.teams)
                $.each(teams, function(i, ele) {
                    if (ele.id == teamId) {
                        ele.role = msg.data.role
                        ele.display_name = msg.data.role_name
                    }
                })
                if (localStorage.team_id == teamId) {
                    localStorage.role = msg.data.role
                }
                localStorage.teams = JSON.stringify(teams)

                let trans = {
                    superadmin: vm.$i18n("超级管理员"),
                    onlooker: vm.$i18n("查看者"),
                    member: vm.$i18n("编辑者"),
                    admin: vm.$i18n("管理员")
                }

                let roleName = trans[msg.data.role]
                if (vm.lang != "en") {
                    roleName = trans[msg.data.role]
                }

                //权限修改
                var msgText = vm.$i18n("你被${username}更改为${role}", {
                    username: msg.data.from_user_name,
                    role: roleName
                })
                vm.eventHub.$emit("notifyToast", {
                    type: "toast",
                    message: msgText
                })
                setTimeout(function() {
                    location.reload()
                }, 1500)
            }
            if (msg.data.type == "team") {
                if (msg.data.method === "refresh") {
                    let id = msg.data.user_id,
                        name = msg.data.user_name
                    setTimeout(() => {
                        window.g.remark.getTeamMemberName("notice", id, name)
                    }, 200)
                }
                if (msg.data.method === "remark") {
                    var text = vm.$i18n("${username} 将你的团队备注修改为 ${remarkName}", {
                        username: msg.data.from_user_name,
                        remarkName: msg.data.remark_name ? msg.data.remark_name : ""
                    })
                    vm.eventHub.$emit("notifyToast", { type: "toast", message: text })
                } else {
                    $.ajax({
                        url: baseUrl + "/account/user_teams",
                        type: "get",
                        success: function(res) {
                            if (msg.data.method == "delete" || msg.data.method == "remove") {
                                socket.emit(
                                    "leave",
                                    {
                                        room: msg.data.team_id
                                    },
                                    function(msg) {
                                        console.log("离开房间:", msg, userId)
                                    }
                                )

                                if (localStorage.team_id == msg.data.team_id) {
                                    if (res.result[0]) {
                                        localStorage.teamName = res.result[0].name
                                        localStorage.role = res.result[0].role.name
                                        localStorage.team_id = res.result[0].id
                                        console.log("删除对方正在显示的团队......")
                                        window.g.remark.getTeamMemberName() //重新获取团队备注表
                                        //当前所在的团队 被移除 跳转到 团队列表页
                                        setTimeout(function() {
                                            router.push({
                                                path: "/item/switch?hideback=true"
                                            })
                                        }, 3000)
                                    }
                                }
                                localStorage.teamStatus = msg.data.method

                                //团队被移除
                                if (msg.data.method == "delete") {
                                    var text = vm.$i18n("${team} 团队已被 ${username} 删除", {
                                        team: msg.data.team_name,
                                        username: msg.data.from_user_name
                                    })
                                } else {
                                    var text = vm.$i18n("你被 ${username} 移出了 ${team} 团队", {
                                        username: msg.data.from_user_name,
                                        team: msg.data.team_name
                                    })
                                }
                                vm.eventHub.$emit("notifyToast", {
                                    type: "toast",
                                    message: text
                                })
                            }
                            localStorage.teams = JSON.stringify(res.result).replace(/display/g, "display_name")
                        }
                    })
                }
            }
            if (msg.data.type == "project") {
                let inProjects = msg.data.team_id == localStorage.team_id
                if ((msg.data.method == "delete" || msg.data.method == "remove") && inProjects) {
                    if (localStorage.user_id == msg.data.targetId) {
                        if (msg.data.method == "remove") {
                            var text = vm.$i18n("你被${username} 移出了 ${project} 项目", {
                                username: msg.data.from_user_name,
                                project: msg.data.project_name
                            })

                            //是被移除对象 并且 拥有这个项目
                            if (localStorage.pid == msg.data.project_id) {
                                //当前打开的项目 是 要被移除的项目
                                setTimeout(function() {
                                    router.push({
                                        path: "/item"
                                    })
                                }, 2000)
                            } else {
                                if (vm.$route.name == "itemIndex") {
                                    setTimeout(() => {
                                        location.reload()
                                    }, 1000)
                                }
                            }
                        }

                        vm.eventHub.$emit("notifyToast", {
                            type: "toast",
                            message: text
                        })
                    }

                    if (msg.data.method == "delete") {
                        var text = vm.$i18n("${project} 项目已被 ${username} 删除", {
                            project: msg.data.project_name,
                            username: msg.data.from_user_name
                        })

                        vm.eventHub.$emit("notifyToast", {
                            type: "toast",
                            message: text
                        })

                        //是被移除对象 并且 拥有这个项目
                        if (localStorage.pid == msg.data.project_id) {
                            //当前打开的项目 是 要被移除的项目
                            setTimeout(function() {
                                router.push({
                                    path: "/item"
                                })
                            }, 2000)
                        } else {
                            if (vm.$route.name == "itemIndex") {
                                setTimeout(() => {
                                    location.reload()
                                }, 1000)
                            }
                        }
                    }
                }
            }
            if (msg.data.type == "email") {
                var text = vm.$i18n("${username} 邀请你加入 ${team} 团队,请前往邮箱查收邮件哦", {
                    username: msg.data.user_name,
                    team: msg.data.team_name
                })

                vm.eventHub.$emit("notifyToast", {
                    type: "toast",
                    message: text
                })
            }
            if (msg.data.method == "modifyName") {
                //修改团队名称的socket通知
                var modifyTeamId = msg.data.team_id
                var modifyTeamName = msg.data.team_name
                var teams = JSON.parse(localStorage.teams)
                $.each(teams, (i, ele) => {
                    if (ele.id == modifyTeamId) {
                        ele.name = modifyTeamName
                    }
                })

                localStorage.teams = JSON.stringify(teams)

                if (localStorage.team_id == modifyTeamId) {
                    localStorage.teamName = modifyTeamName
                }
            }
        })
    })
}
